
//live
export const backend="https://dark-learn-uu3i.vercel.app"

//Test
// export const backend="http://localhost:5000"
//...
